export default __webpack_public_path__ + "static/media/Central.7307865f.png";